export const DisplayedColumns = [
  'description',
  'dateTime',
  'count',
  'number',
  'printed',
  'options',
];
